import styles from './QCNotesDrawer.module.css';

export interface QCNotesDrawerStep {
  id: string;
  label: string;
  value: string;
  fieldName?: string;
  flagged?: boolean;
}

export interface QCNotesDrawerProps {
  open: boolean;
  steps: QCNotesDrawerStep[];
  onChange: (stepId: string, value: string) => void;
  onClose: () => void;
}

export function QCNotesDrawer({ open, steps, onChange, onClose }: QCNotesDrawerProps) {
  if (!open) {
    return null;
  }

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true">
      <div className={styles.drawer}>
        <div className={styles.header}>
          <div>
            <h2 className={styles.title}>QC Notes</h2>
            <p className={styles.subtitle}>Document quality check findings for each workflow step.</p>
          </div>
          <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close notes">
            ×
          </button>
        </div>
        <div className={styles.body}>
          {steps.map((step) => (
            <div key={step.id} className={styles.noteBlock}>
              <div className={styles.noteHeader}>
                <h3 className={styles.noteHeading}>{step.label}</h3>
                {step.fieldName && (
                  <span className={styles.fieldName}>
                    {step.fieldName}
                  </span>
                )}
                {step.flagged && (
                  <span className={styles.flagBadgeActive}>
                    🚩 Flagged
                  </span>
                )}
              </div>
              <textarea
                className={styles.textarea}
                value={step.value}
                onChange={(event) => onChange(step.id, event.target.value)}
                rows={4}
                placeholder="Add notes, blockers, or follow-up tasks."
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default QCNotesDrawer;
